import { Component, OnInit } from '@angular/core';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { NavigateService } from 'src/app/core/services/navigate.service';

@Component({
    selector: 'ms-vertical-solutions-management',
    templateUrl: './vertical-solutions-management.component.html',
    styleUrls: ['./vertical-solutions-management.component.scss'],
})
export class VerticalSolutionsManagementComponent implements OnInit {
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    constructor(public navigateService: NavigateService) {}

    ngOnInit(): void {

    }
}
